import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from '@/lang/i18n'
import "./plugins/vuetifyx"
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

// The OAuth2 loopback callback is now handled by the routed view
// src/views/oauth2-callback/OAuth2Callback.vue (path /user/oauth2/callback).
Vue.config.productionTip = false
Vue.use(Loading)

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
